import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState, useEffect } from 'preact/hooks';
import { useLookups } from '@/hooks/useLookups';
export function CountryDropdown({ value, onChange, error, disabled }) {
    const { getCountries } = useLookups();
    const [countrySearch, setCountrySearch] = useState('');
    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const filteredCountries = getCountries()
        .filter(c => countrySearch === '' ||
        c.Description.toLowerCase().includes(countrySearch.toLowerCase()) ||
        c.Key.toLowerCase().includes(countrySearch.toLowerCase()))
        .sort((a, b) => a.Description.localeCompare(b.Description));
    // Initialize country search with current country name when value changes
    useEffect(() => {
        if (value) {
            const country = getCountries().find(c => c.Key === value);
            if (country) {
                setCountrySearch(country.Description);
            }
        }
        else {
            setCountrySearch('');
        }
    }, [value, getCountries]);
    return (_jsxs("div", { className: "relative", children: [_jsx("input", { type: "text", value: countrySearch, onInput: (e) => {
                    setCountrySearch(e.target.value);
                    setShowCountryDropdown(true);
                }, onFocus: () => setShowCountryDropdown(true), onBlur: () => {
                    // Delay to allow click on dropdown item
                    setTimeout(() => setShowCountryDropdown(false), 200);
                }, className: `w-full px-3 py-2 border rounded-md bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 ${error
                    ? 'border-red-300 dark:border-red-600 focus:ring-red-500'
                    : 'border-slate-300 dark:border-slate-600 focus:ring-primary-500 dark:focus:ring-primary-400'}`, placeholder: "Type to search countries...", disabled: disabled, autoComplete: "off" }), showCountryDropdown && filteredCountries.length > 0 && (_jsx("div", { className: "absolute z-50 w-full bottom-full mb-1 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md shadow-lg max-h-60 overflow-auto", children: filteredCountries.slice(0, 50).map(c => (_jsxs("button", { type: "button", onClick: () => {
                        setCountrySearch(c.Description);
                        onChange(c.Key);
                        setShowCountryDropdown(false);
                    }, className: "w-full text-left px-3 py-2 hover:bg-slate-100 dark:hover:bg-slate-600 text-slate-900 dark:text-slate-100 text-sm", children: [_jsx("span", { className: "font-medium", children: c.Description }), _jsxs("span", { className: "ml-2 text-slate-500 dark:text-slate-400 text-xs", children: ["(", c.Key, ")"] })] }, c.Key))) })), error && _jsx("p", { className: "mt-1 text-sm text-red-600 dark:text-red-400", children: error })] }));
}
